import { ActionCreator } from 'redux';
import { ThunkAction, Dispatch } from '../../../../types/actions';
import { TBoardId } from '../../../../types/types';
import { listViewActionSet } from '../store/listView/actions/listViewActionSet';
import { groupByEpicsToggleAction } from '../store/listViewBoard/actions/groupByEpicsToggle';
import { IGetState } from '../../../../types/types';
import { setLocalStorageItem } from '../helpers/setLocalStorageItem';
import { getGroupByEpics } from '../selectors/getGroupByEpics';
import { groupByEpicsGoogleAnalyticsEvents } from './googleAnalyticsEvents';
import { blockerSet } from './blockerSet';
import { groupByEpicsSegmentEvent } from './segmentEvents';

export const groupByEpicsToggle: ActionCreator<ThunkAction> = (
    boardId: TBoardId
) => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const isGrouped = getGroupByEpics(state, boardId);
        // dispatch(blockerSet(boardId, true));
        setTimeout(() => {
            dispatch(listViewActionSet(boardId, groupByEpicsToggleAction()));
            dispatch(groupByEpicsGoogleAnalyticsEvents(!isGrouped));
            dispatch(groupByEpicsSegmentEvent(isGrouped));
            setLocalStorageItem(boardId);
            // setTimeout(() => {
            //     dispatch(blockerSet(boardId, false));
            // }, 0);
        }, 0);
    };
    return action;
};
